var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('heading',{staticClass:"col-12 q-mb-md",attrs:{"header":"تنظیمات حساب کاربری"}})],1),_c('user-information',{attrs:{"info":_vm.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }